import { Box, Tab, Tabs, CircularProgress, css } from '@mui/material';
import { useState, useEffect } from 'react';
import alertify from 'alertifyjs';

import { LayerDashboardTab } from './LayerDashboardTab';
import { SummaryDashboardTab } from './SummaryDashboardTab';
import { LayerDashboardTabProvider } from '../../features/layer-dashboard/context/LayerDashboardContext';
import { useGetLayerDashboardInfo } from 'features/layer-dashboard/api/layerDashboardApi';
import { getLayerDashboardUrlParams } from 'features/layer-dashboard/utils/layoutDashboardUrlUtils';
import { ILayerDashboard } from 'features/layer-dashboard/model/ILayerDashboardMainResponse';
import { LayerGroupDashboard } from './LayerGroupDashboard';
import { RenderLayerOrGroup } from 'features/layer-dashboard/enums/RenderLayerOrGroup';
import { LayerDashboard } from './LayerDashboard';

const urlParams = getLayerDashboardUrlParams();

const loading = css({
    background: '#c8c8c8',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export const Dashboard = () => {
    const [renderLayerOrGroup, setRenderLayerOrGroup] = useState<RenderLayerOrGroup>(RenderLayerOrGroup.undefined);

    useEffect(() => {
        if (urlParams) {
            if (!urlParams.dashboardGroupToken || urlParams.dashboardGroupToken === 'undefined' || urlParams.dashboardGroupToken === 'null') {
            //if (!urlParams.dashboardGroupToken || urlParams.dashboardGroupToken === 'undefined') {
                setRenderLayerOrGroup(RenderLayerOrGroup.layer);
            }
            else {
                setRenderLayerOrGroup(RenderLayerOrGroup.group);
            }
        }
    }, [urlParams]);

    return (
        <Box sx={{ width: '100%' }}>
            {renderLayerOrGroup === RenderLayerOrGroup.layer ? (
                <LayerDashboard />
            ) : renderLayerOrGroup === RenderLayerOrGroup.group ? (
                <LayerGroupDashboard />
            ) : null}
        </Box>
    );
};